import data from "../../../../../src/Textarea.docs.json";
import { Textarea } from '@primer/react';
import * as React from 'react';
export default {
  data,
  Textarea,
  React
};